import axios from "axios";
import { useQuery } from "react-query";
import { sanitize } from "dompurify";

export default function usePensionProductInfo(pensionProduct: string) {
  async function retrievePensionProductInfo(
    pensionProduct: string,
  ): Promise<string> {
    const basepath: string = process.env.REACT_APP_PATH || "";

    const filePath = `${basepath}/pension-product-info/${pensionProduct}.html`;

    const response = await axios.get(filePath);

    return sanitize(response.data as string, { ADD_ATTR: ["target"] });
  }

  return useQuery(
    ["pensionproductinfo", pensionProduct],
    async () => await retrievePensionProductInfo(pensionProduct),
    {
      refetchOnWindowFocus: false,
    },
  );
}
